// Copyright (c) 2017 Deere & Company

import ProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import t from 'tcomb';

const Products = t.list(ProductSearchResult, 'Products');

export const getDefaultState = () => new Products([]);

export default Products;



// WEBPACK FOOTER //
// ./src/product/products-by-customer/state/products.js